import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const APP_URL = 'https://app.theonestack.com';
const AMS_PATH = '/ams';

const links = [
  { label: 'Features', href: '#features' },
  { label: 'Verticals', href: '#verticals' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Contact', href: '#contact' },
];

export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 z-50 w-full nav-glass ${scrolled ? 'scrolled' : ''}`}>
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2.5">
          <AmsIcon />
          <span className="text-lg font-semibold tracking-tight">TheOne AMS</span>
        </a>

        {/* Desktop links */}
        <div className="hidden items-center gap-8 text-sm text-zinc-400 md:flex">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="transition hover:text-zinc-100">
              {l.label}
            </a>
          ))}
          <a href={`${APP_URL}${AMS_PATH}`} className="transition hover:text-zinc-100">
            Sign In
          </a>
        </div>

        {/* Desktop CTA */}
        <a
          href={`${APP_URL}${AMS_PATH}`}
          className="hidden rounded-lg bg-ams-500 px-5 py-2 text-sm font-medium text-white transition hover:bg-ams-600 md:block"
        >
          Start Free Trial
        </a>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-zinc-400 hover:text-zinc-100"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="border-t border-ams-800/30 bg-[#0a0f0d]/95 px-6 py-4 backdrop-blur-xl md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="block py-3 text-sm text-zinc-400 transition hover:text-zinc-100"
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <a
            href={`${APP_URL}${AMS_PATH}`}
            className="block py-3 text-sm text-zinc-400 transition hover:text-zinc-100"
          >
            Sign In
          </a>
          <a
            href={`${APP_URL}${AMS_PATH}`}
            className="mt-2 block rounded-lg bg-ams-500 py-3 text-center text-sm font-medium text-white"
          >
            Start Free Trial
          </a>
        </div>
      )}
    </nav>
  );
}

function AmsIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="6" fill="#042f2e" />
      <path
        d="M8 24V14L16 8L24 14V24"
        stroke="url(#nav-ams-grad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="16" cy="17" r="3.5" stroke="#2dd4bf" strokeWidth="1.5" fill="none" />
      <path d="M16 13.5V10" stroke="#2dd4bf" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M12 24V20H20V24"
        stroke="url(#nav-ams-grad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <defs>
        <linearGradient id="nav-ams-grad" x1="8" y1="8" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5eead4" />
          <stop offset="1" stopColor="#0d9488" />
        </linearGradient>
      </defs>
    </svg>
  );
}
